import React from "react";
import { useTranslation } from "react-i18next";
import "./LoadingSpinner.css";

function LoadingSpinner({ message, fullScreen = false }) {
  const { t } = useTranslation();
  // SVG path coordinates for the Surveillance Shield icon
  const shieldPath =
    "M11.46 20.846C8.44929 19.9127 5.92666 17.8324 4.43721 15.0545C2.94777 12.2765 2.61111 9.02411 3.5 6C6.61553 6.14257 9.66417 5.06658 12 3C14.3358 5.06658 17.3845 6.14257 20.5 6C21.1787 8.30911 21.1473 10.7689 20.41 13.06M15 19L17 21L21 17";

  return (
    <div className={`loading-spinner-container ${fullScreen ? "full-screen" : "inline-container"}`}>
      <div className="loader-container">
        {/* Logo Container for pulsing shield and wireframe laser scanner */}
        <div className="logo-container">
          <svg
            className="loader-logo-svg"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d={shieldPath}
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="scan-line"></div>
        </div>

        {/* Branded text title or custom message */}
        <h1 className="loader-brand-title">{message || t("loading.default")}</h1>

        {/* Horizontal Infinite Progress Bar */}
        <div className="loader-progress-track">
          <div className="loader-progress-fill"></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;